import CreateStaffMemberProfileModal from './CreateStaffMemberProfileModal.container';

export default CreateStaffMemberProfileModal;
